export default __webpack_public_path__ + "static/media/portrait8.75f8f8af.JPG";